// Default State


export const state = {
    currentId: 0,
    bal: 0,
    RecipeDate: {
      1: {
        name: 'Бургер с семгой',
        time: '25 минут',
        portion: '8 порций',
        image: '/static/images/recieps/rec1.jpg',
        ingredients: [
          {
            index: 0,
            text: 'ФИЛЕ СЕМГИ',
            value: '400 г'
          },
          {
            index: 1,
            text: 'ВУСТЕРШИРСКИЙ СОУС',
            value: '1 чайная ложка'
          },
          {
            index: 2,
            text: 'ЛУК-РЕЗАНЕЦ',
            value: '1 столовая ложка'
          },
          {
            index: 3,
            text: 'КОПЧЕНАЯ ПАПРИКА',
            value: '1 чайная ложка'
          },
          {
            index: 4,
            text: 'ПОМИДОРЫ ПЛАМ',
            value: '4 штуки'
          },
          {
            index: 5,
            text: 'МОЛОТЫЙ СУШЕНЫЙ ЛУК',
            value: '1 чайная ложка'
          },
          {
            index: 6,
            text: 'КРАСНЫЙ ЛУК',
            value: '1,5 головки'
          },
          {
            index: 7,
            text: 'ЧЕСНОК',
            value: '2,5 зубчика'
          },
          {
            index: 8,
            text: 'РУБЛЕННАЯ КИНЗА (КОРИАНДР)',
            value: '1 столовая ложка'
          },
          {
            index: 9,
            text: 'БЕЛЫЙ ВИННЫЙ УКСУС',
            value: '1 чайная ложка'
          },
          {
            index: 10,
            text: 'ОЛИВКОВОЕ МАСЛО EXTRA VIRGIN',
            value: '1 чайная ложка'
          },
          {
            index: 11,
            text: 'МАЙОНЕЗ',
            value: '400 г'
          },
          {
            index: 12,
            text: 'АПЕЛЬСИНОВЫЙ СОК',
            value: '80 мл'
          },
          {
            index: 13,
            text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
            value: '40 г'
          },
          {
            index: 14,
            text: 'СЫР',
            value: '8 кусков'
          },
          {
            index: 15,
            text: 'БУЛОЧКА ДЛЯ ГАМБУРГЕРОВ',
            value: '8 штук'
          },
          {
            index: 16,
            text: 'ЗЕЛЕНЫЙ САЛАТ',
            value: '8 штук'
          },
          {
            index: 17,
            text: 'ПОДСОЛНЕЧНОЕ МАСЛО',
            value: 'по вкусу'
          },
          {
            index: 18,
            text: 'СОЛЬ',
            value: 'по вкусу'
          }
        ],
        instruction: [
          {
            id: 0,
            text: 'Для майонеза чипотле смешать майонез (домашний или фабричный), мелко нарубленную красную луковицу, апельсиновый сок, два нарубленных зубчика чеснока и приправу чипотле. Посолить по вкусу. Мешать можно вручную, но проще блендером.'
          },
          {
            id: 1,
            text: 'Для томатной сальсы удалить у помидоров семена и нарезать небольшими кубикам. Половину красной луковицы мелко нарубить. Половину зубчика чеснока натереть на терке. Перемешать лук, помидоры и чеснок с кинзой, заправить винным уксусом и оливковым маслом.'
          },
          {
            id: 2,
            text: 'Три четверти семги превратить в мелкий фарш с помощью мясорубки, оставшееся — нарубить мелкими кубиками. Добавить вустерширский соус, лук-резанец, луковый порошок, копченую паприку, по вкусу посолить. Тщательно перемешать, чтобы получилась плотная однородная масса.'
          },
          {
            id: 3,
            text: 'Слепить из фарша небольшие ­котлеты — восемь штук. Обжарить на подсолнечном масле на сковороде гриль — по мину­те с каждой стороны.'
          },
          {
            id: 4,
            text: 'Булочки разрезать надвое, смазать обе половины майонезом чипотле. На нижние половины выложить по листу салата. Затем — по рыбной котлете с ломтиком сыра (ярлсберг), поверх сыра добавить сальсу — и накрыть верхними половинами булочек. ­Подавать с картофелем фри — или есть просто так.'
          }

        ]
      },
      2: {
        name: 'Сэндвичи с тунцом и сыром',
        time: '10 минут',
        portion: '4 порции',
        image: '/static/images/recieps/rec2.jpg',
        ingredients: [
          {
            index: 0,
            text: 'КОНСЕРВИРОВАННЫЙ ТУНЕЦ В СОБСТВЕННОМ СОКУ',
            value: '1 банка'
          },
          {
            index: 1,
            text: 'ХЛЕБ ДЛЯ ТОСТОВ',
            value: '8 кусков'
          },
          {
            index: 2,
            text: 'СЫР ЭММЕНТАЛЬ',
            value: '200 г'
          },
          {
            index: 3,
            text: 'РОЗОВЫЙ ПЕРЕЦ',
            value: 'по вкусу'
          },
          {
            index: 4,
            text: 'КАПЕРСЫ',
            value: '½ чайной ложки'
          },
          {
            index: 5,
            text: 'СЛИВОЧНОЕ МАСЛО',
            value: '20 г'
          },
          {
            index: 6,
            text: 'ОГУРЦЫ',
            value: '½ штуки'
          }

        ],
        instruction: [
          {
            id: 0,
            text: 'Тунца вместе с соком выложить в миску и размять руками. Посыпать розовым маврикийским перцем (он такой же ароматный, как черный, но менее жгучий), добавить каперсы и перемешать. Выложить тертый эмменталь (или другой сыр по вкусу — эдам, например, или гауду) и снова перемешать.'
          },
          {
            id: 1,
            text: 'Разогреть сковороду на среднем огне и слегка подсушить хлеб с обеих сторон. Затем слегка промазать все куски с одной стороны сливочным маслом, выложить тунцово-сырную смесь, соединить половины сэндвичей — и снова отправить на сковородку. Там они должны провести пару минут под крышкой — идея в том, чтобы сыр расплавился и схватил рыбную массу.'
          },
          {
            id: 2,
            text: 'Готовые сэндвичи разрезать по диагонали и украсить кружками огурца.'
          }
        ]
      },
      3: {
        name: 'Персики на гриле с горгонзолой и медом',
        time: '15 минут',
        portion: '4 порции',
        image: '/static/images/recieps/rec3.jpg',
        ingredients: [
          {
            index: 0,
            text: 'ПЕРСИКИ',
            value: '4 штуки'
          },
          {
            index: 1,
            text: 'СЫР ГОРГОНЗОЛА',
            value: '100 г'
          },
          {
            index: 2,
            text: 'ЛАЙМ',
            value: '1 штука'
          },
          {
            index: 3,
            text: 'МЕД',
            value: '100 г'
          },
          {
            index: 4,
            text: 'КОРИЧНЕВЫЙ САХАР',
            value: '60 г'
          },
          {
            index: 5,
            text: 'МЯТА',
            value: '4 стебля'
          },
          {
            index: 6,
            text: 'СВЕЖЕМОЛОТЫЙ ЧЕРНЫЙ ПЕРЕЦ',
            value: 'по вкусу'
          }

        ],
        instruction: [
          {
            id: 0,
            text: 'Персики опустить на минуту в кипяток, остудить и снять кожицу. Разрезать на половинки и удалить косточки.'
          },
          {
            id: 1,
            text: 'Посыпать половинки персиков сахаром и обжарить на гри­ле с обеих сторон (примерно по полторы минуты с каждой стороны). Положить по кусочку горгонзолы в каждую из половинок и приправить свеже­молотым перцем.'
          },
          {
            id: 2,
            text: 'Помешивая, разогреть в сотейнике мед с соком лайма — до карамелизации (он начнет пениться, как масло на сковороде). ­Полить этим соусом персики и украсить листьями мяты.'
          }
        ]
      },
      4: {
        name: 'Овощи гриль с соусом из печеного чеснока',
        time: '25 минут',
        portion: '2 порций',
        image: '/static/images/recieps/rec-new-gril-chesnok.jpg',
        ingredients: [
          {
            index: 0,
            text: 'СЛАДКИЙ ПЕРЕЦ',
            value: '250 г'
          },
          {
            index: 1,
            text: 'ЗЕЛЕНАЯ СПАРЖА',
            value: '70 г'
          },
          {
            index: 2,
            text: 'ЦУКИНИ',
            value: '250 г'
          },
          {
            index: 3,
            text: 'ПЕРЕЦ ЧИЛИ',
            value: '1 штука'
          },
          {
            index: 4,
            text: 'ПОМИДОРЫ ЧЕРРИ',
            value: '100 г'
          },
          {
            index: 5,
            text: 'ЛУК-ШАЛОТ',
            value: '130 г'
          },
          {
            index: 6,
            text: 'РОЗМАРИН',
            value: '10 г'
          },
          {
            index: 7,
            text: 'КИНЗА',
            value: '30 г'
          },
          {
            index: 8,
            text: 'ЧЕСНОК',
            value: '2 головки'
          },
          {
            index: 9,
            text: 'САХАР',
            value: '15 г'
          },
          {
            index: 10,
            text: 'ОЛИВКОВОЕ МАСЛО',
            value: '115 мл'
          },
          {
            index: 11,
            text: 'БАЛЬЗАМИЧЕСКИЙ УКСУС',
            value: '20 мл'
          },
          {
            index: 12,
            text: 'СОЛЬ',
            value: 'по вкусу'
          },
          {
            index: 13,
            text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
            value: 'по вкусу'
          }

        ],
        instruction: [
          {
            id: 0,
            text: 'Разрежьте цукини вдоль и нарежьте его полукольцами по 1,5 см, отрежьте сухие концы спаржи, нарежьте перец и лук крупными кусками.'
          },
          {
            id: 1,
            text: 'Разрежьте головки чеснока и чили перец на 2 части поперек.'
          },
          {
            id: 2,
            text: 'Выложите все овощи на противень, полейте их умеренным количеством оливкового масла и уксусом, посолите, поперчите.'
          },
          {
            id: 3,
            text: 'Отложите две макушки розмарина. Остальными веточками розмарина посыпьте овощи и запекайте в разогретой до 250 градусов духовке в режиме вертикального гриля в течение 10 минут.'
          },
          {
            id: 4,
            text: 'Переложите овощи в емкость, достаньте чеснок, накройте остальные овощи фольгой.'
          },
          {
            id: 5,
            text: 'Выдавите зубчики чеснока и поместите их в емкость; добавьте кинзу со стеблем, сахар, посолите, поперчите, добавьте 80 мл оливкового масла и пробейте блендером в крупную крошку.'
          },
          {
            id: 6,
            text: 'Перемешайте овощи с 2/3 соуса, разложите по тарелкам, украсьте макушками розмарина и подавайте. Оставшийся соус подайте в пиалке.'
          }
        ]
      },
      5: {
        name: 'Дорада на гриле с мандаринами и майораном',
        time: '20 минут',
        portion: '4 порции',
        image: '/static/images/recieps/rec5.jpg',
        ingredients: [
          {
            index: 0,
            text: 'МАЙОРАН',
            value: '1 пучок'
          },
          {
            index: 1,
            text: 'ДОРАДО',
            value: '2 штуки'
          },
          {
            index: 2,
            text: 'МАНДАРИНЫ',
            value: '2 штуки'
          },
          {
            index: 3,
            text: 'ОЛИВКОВОЕ МАСЛО',
            value: '20 мл'
          },
          {
            index: 4,
            text: 'СОЛЬ',
            value: 'по вкусу'
          },
          {
            index: 5,
            text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
            value: 'по вкусу'
          }
        ],
        instruction: [
          {
            id: 0,
            text: 'Хорошо разогреть гриль. На выпотрошенных тушках рыбы сделать с одной стороны по три глубоких диагональных надре­за на расстоянии в 2–3 см. Натереть солью и перцем кожу и брюшки.'
          },
          {
            id: 1,
            text: 'Нафаршировать каждую рыбу четырьмя целыми веточками майорана и дольками одного мандарина (нужно распределить их поровну между двумя тушками). Тщательно смазать дораду оливковым маслом со всех сторон.'
          },
          {
            id: 2,
            text: 'Жарить на гриле по 3–4 минуты с каждой стороны, затем переложить рыбу на сервировочное блюдо и украсить дольками оставшегося мандарина, а также посыпать листьями c оставшихся веточек майорана.'
          }
        ]
      },
      6: {
        name: 'Зажаренная на гриле капуста',
        time: '40 минут',
        portion: '8 порции',
        image: '/static/images/recieps/rec6.jpg',
        ingredients: [
            {
                index: 0,
                text: 'СОЛЬ',
                value: 'по вкусу'
            },
            {
                index: 1,
                text: 'БЕЛОКОЧАННАЯ КАПУСТА',
                value: '3 кг'
            },
            {
                index: 2,
                text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                value: 'по вкусу'
            },
            {
                index: 3,
                text: 'ТОПЛЕНОЕ МАСЛО',
                value: 'по вкусу'
            }
        ],
        instruction: [
            {
                id: 0,
                text: 'Кочаны капусты выложить на ­хорошо разогретый гриль и закрыть крышкой сверху. В жаре и дыму капуста отлично запечется примерно за полчаса. Можно в течение этого времени кочан несколько раз перевернуть, чтобы его листья обгорали равномерно со всех сторон.'
            },
            {
                id: 1,
                text: 'Сгоревшие листья надо оборвать, капусту нарезать большими кусками, посолить, поперчить, а также — для усиления вкуса — полить растопленным тут же на гриле в подходящей емкости маслом.'
            }
        ]
    },
      7: {
        name: 'Ананас на гриле с кардамоном и ванильным мороженым',
        time: '15 минут',
        portion: '6 порции',
        image: '/static/images/recieps/rec7.jpg',
        ingredients: [
        {
            index: 0,
            text: 'ПАТОКА',
            value: '50 г'
        },
        {
            index: 1,
            text: 'СЛИВОЧНОЕ МАСЛО',
            value: '60 г'
        },
        {
            index: 2,
            text: 'КОРОБОЧКИ КАРДАМОНА',
            value: '8 штук'
        },
        {
            index: 3,
            text: 'СОК ЛАЙМА',
            value: '2 чайные ложки'
        },
        {
            index: 4,
            text: 'АНАНАС',
            value: '1 штука'
        },
        {
            index: 5,
            text: 'АРАХИСОВОЕ МАСЛО',
            value: '2 столовые ложки'
        },
        {
            index: 6,
            text: 'ВАНИЛЬНОЕ МОРОЖЕНОЕ',
            value: 'по вкусу'
        }
    ],
        instruction: [
            {
                id: 0,
                text: 'Разогреть гриль. Ананас очистить, удалить сердцевину и нарезать кружками толщиной 5 мм. Смешать патоку и масло в сотейнике, добавить раздавленные коробочки кардамона, довести до кипения и варить пять минут. Снять с огня, влить сок лайма.'
            },
            {
                id: 1,
                text: 'Смазать кольца сиропом и поджарить с двух сторон в течение четырех минут, а за тридцать секунд до готовности смазать еще раз, чтобы глазурь получилась плотной. Подавать с ваниль­ным мороженым.'
            }
        ]
      },
      8: {
        name: 'Порей с чесночным майонезом',
        time: '20 минут',
        portion: '6 порции',
        image: '/static/images/recieps/rec8.jpg',
        ingredients: [
            {
                index: 0,
                text: 'СЛАДКИЙ ПЕРЕЦ',
                value: '1 штука'
            },
            {
                index: 1,
                text: 'ЛУК-ПОРЕЙ',
                value: '36 стеблей'
            },
            {
                index: 2,
                text: 'ЛИМОН',
                value: '1 штука'
            },
            {
                index: 3,
                text: 'ЧЕСНОК',
                value: '8 зубчиков'
            },
            {
                index: 4,
                text: 'МАЙОНЕЗ',
                value: '500 г'
            },
            {
                index: 5,
                text: 'СОЛЬ',
                value: 'по вкусу'
            },
            {
                index: 6,
                text: 'ШАФРАН',
                value: 'на кончике ножа'
            }
        ],
        instruction: [
            {
                id: 0,
                text: 'Шепотку шафрана развести в двадцати миллилитрах кипятка. Сладкий перец обжарить на гриле так, чтобы кожица начала лопаться и обугливаться. Снять с огня, срезать по максимуму всю кожицу, выкинуть семечки и прочую начинку и мелко нарубить перец. Дать шафрану настояться пять минут и смешать настой с майонезом, мелко нарубленным перцем, давленым чесноком, соком лимона и солью.'
            },
            {
                id: 1,
                text: 'Стебли порея обжарить на решетке над костром, не смущаясь того, что верхние слои начнут обугливаться и подгорать. Обжаривать минут пять, постоян­но переворачивая. Снять порей с огня и есть, обрывая верхние — обожженные слои и макая в острый чесночный майонез.'
            }
        ]
        },
      9: {
        name: 'Овощи с грибами на гриле по‑итальянски',
        time: '30 минут',
        portion: '4 порции',
        image: '/static/images/recieps/rec-new-gril-ital.jpg',
        ingredients: [
            {
                index: 0,
                text: 'КРАСНЫЙ ЛУК',
                value: '4 головки'
            },
            {
                index: 1,
                text: 'КРАСНЫЙ СЛАДКИЙ ПЕРЕЦ',
                value: '4 штуки'
            },
            {
                index: 2,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '2 чайные ложки'
            },
            {
                index: 3,
                text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                value: 'по вкусу'
            },
            {
                index: 4,
                text: 'ГРИБЫ ПОРТОБЕЛЛО',
                value: '6 штук'
            },
            {
                index: 5,
                text: 'СВЕЖАЯ СПАРЖА',
                value: '900 г'
            }
        ],
        instruction: [
            {
                id: 0,
                text: 'Приготовьте чесночный винегрет с чили'
            },
            {
                id: 1,
                text: 'Разогрейте гриль или мангал.'
            },
            {
                id: 2,
                text: 'Разрежьте перцы пополам и очистите, луковицы порежьте на 6 кусков. Сбрызните растительным маслом и перемешайте.'
            },
            {
                id: 3,
                text: 'Выложите перцы и лук на гриль и жарьте примерно 15 минут, переворачивая, пока кожица у перцев не станет подгорать. Переложите перцы в пластиковый пакет и оставьте на 15 минут. Очистите от кожицы и порежьте на длинные полоски. Переложите в миску.'
            },
            {
                id: 4,
                text: 'Порежьте лук на небольшие кусочки и добавьте к перцам.'
            },
            {
                id: 5,
                text: 'Сбрызните спаржу и грибы оливковым маслом, перемешайте и выложите на гриль. Жарьте, переворачивая, примерно 3 минуты до мягкости.'
            },
            {
                id: 6,
                text: 'Порежьте грибы на небольшие кусочки и добавьте к луку и перцам. Затем порежьте спаржу по диагонали на небольшие кусочки и переложите к овощам. Сбрызните приготовленным чесночным винегретом и аккуратно перемешайте.'
            }
        ]
      },

      10: {
        name: 'Бургеры из киноа',
        time: '35 минут',
        portion: '12 порций',
        image: '/static/images/recieps/rec10.jpg',
        ingredients: [
            {
                index: 0,
                text: 'КИНОА',
                value: '250 г'
            },
            {
                index: 1,
                text: 'ЯЙЦО КУРИНОЕ',
                value: '1 штука'
            },
            {
                index: 2,
                text: 'ТВОРОГ',
                value: '120 г'
            },
            {
                index: 3,
                text: 'КРАСНЫЙ ЛУК',
                value: '1 головка'
            },
            {
                index: 4,
                text: 'ПЕРЬЯ ЧЕСНОКА',
                value: '40 г'
            },
            {
                index: 5,
                text: 'ПЕРЕЦ ЧИЛИ',
                value: '1 штука'
            },
            {
                index: 6,
                text: 'РИСОВАЯ МУКА',
                value: '2,5 столовые ложки'
            },
            {
                index: 7,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: 'по вкусу'
            },
            {
                index: 8,
                text: 'КУМИН (ЗИРА)',
                value: '2 чайные ложки'
            },
            {
                index: 9,
                text: 'СОЛЬ',
                value: 'по вкусу'
            },
            {
                index: 9,
                text: 'ТЕРТЫЙ СЫР ПАРМЕЗАН',
                value: '30 г'
            }
        ],
        instruction: [
            {
                id: 0,
                text: 'Промыть киноа, залить водой в соотношении 1:2, довести до кипения и варить одиннадцать минут. Остудить.'
            },
            {
                id: 1,
                text: 'В остывшую киноа добавить слегка взбитое яйцо, мелко на­резанные зеленые побеги чес­нока (или черемшу), перец чили и среднюю красную луковицу, нежирный сухой творог, тертый сыр — вместо пармезана можно взять чеддер. Все хорошо перемешать.'
            },
            {
                id: 2,
                text: 'Посолить фарш, добавить одну столовую ложку рисовой муки. Смесь должна получиться густой и липкой.'
            },
            {
                id: 3,
                text: 'Сформировать нетолстые бургеры, слегка присыпать их рисовой мукой и обжарить на оливковом масле. Подавать с острым томатным или перечным соусом.'
            },
        ]
      },
      11: {
        name: 'Стейки с картофелем и спаржей на гриле',
        time: '25 минут',
        portion: '4 порции',
        image: '/static/images/recieps/rec11.jpg',
        ingredients: [
            {
                index: 0,
                text: 'ГОВЯЖИЙ СТЕЙК',
                value: '4 штуки'
            },
            {
                index: 1,
                text: 'КАРТОФЕЛЬ',
                value: '8 штук'
            },
            {
                index: 2,
                text: 'СПАРЖА',
                value: '12 стеблей'
            },
            {
                index: 3,
                text: 'ЛИМОН',
                value: '½ штуки'
            },
            {
                index: 4,
                text: 'ОЛИВКОВОЕ МАСЛО',
                value: '60 мл'
            },
            {
                index: 5,
                text: 'СЛИВОЧНОЕ МАСЛО',
                value: '60 г'
            },
            {
                index: 6,
                text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                value: '80 г'
            },
            {
                index: 7,
                text: 'РОЗМАРИН',
                value: '1 г'
            },
            {
                index: 8,
                text: 'ТИМЬЯН',
                value: '1 г'
            },
            {
                index: 9,
                text: 'СОЛЬ',
                value: 'по вкусу'
            },
            {
                index: 10,
                text: 'СВЕЖИЙ ПЕРЕЦ',
                value: 'по вкусу'
            }
        ],
        instruction: [
            {
                id: 0,
                text: 'Картофель отварить, сняв с огня за пару минут до готовности, — он должен остаться твердым. Дать остыть, разрезать вдоль на половинки.'
            },
            {
                id: 1,
                text: 'Спаржу очистить, опустить в кипящую воду на две минуты, затем переложить на минуту в воду со льдом — холод помогает сохранить цвет продукта, в тепле спаржа станет рыжеватого цвета.'
            },
            {
                id: 2,
                text: 'С веток тимьяна и розмарина оборвать листья, мелко нарезать их. Втереть в зелень соль, чтобы листья дали больше сока, поперчить, залить 60 мл оливкового масла и лимонным соком, хоро­шо перемешать.'
            },
            {
                id: 3,
                text: 'Стейки поперчить и обжарить на сковороде гриль (на рас­тительном масле), картофель и спар­жу тоже поперчить и обжарить отдельно, тоже на сковороде гриль, но на сливочном, до зо­лотистой корочки. Во вре­мя жарки полить овощи заправкой из сока лимона, оливкового масла и пряных трав.'
            }
        ]
      },
      12: {
            name: 'Тальята',
            time: '15 минут',
            portion: '6 порций',
            image: '/static/images/recieps/rec12.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'ЛИМОН',
                    value: '1 штука'
                },
                {
                    index: 1,
                    text: 'ЧЕСНОК',
                    value: '4 зубчика'
                },
                {
                    index: 2,
                    text: 'ОЛИВКОВОЕ МАСЛО',
                    value: '100 мл'
                },
                {
                    index: 3,
                    text: 'РОЗМАРИН',
                    value: '4 стебля'
                },
                {
                    index: 4,
                    text: 'РУККОЛА',
                    value: '150 г'
                },
                {
                    index: 5,
                    text: 'СЫР ПАРМЕЗАН',
                    value: '100 г'
                },
                {
                    index: 6,
                    text: 'СИРЛОЙН-СТЕЙК',
                    value: '900 г'
                },
                {
                    index: 7,
                    text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                    value: 'по вкусу'
                },
                {
                    index: 8,
                    text: 'СОЛЬ',
                    value: 'по вкусу'
                },
                {
                    index: 9,
                    text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                    value: '30 мл'
                }
            ],
            instruction: [
                {
                    id: 0,
                    text: 'Нежирный стейк сирлойн толщиной примерно 1 см просушить бумажными салфетками и посолить. Раскалить сковороду, спрыснутую растительным маслом, оно защитит мясо от прилипания к горячей поверхности. Раскалить, пока масло не начнет чуть-чуть дымить.'
                },
                {
                    id: 1,
                    text: 'Бросить мясо на сковороду и жарить две-три минуты (в зависимости от того, какая степень прожарки нужна: две минуты для medium rare, три — medium), переворачивая каждые двадцать секунд. Частота вра­щения также позволяет мясу не подгорать и не образовывать толстую корку.'
                },
                {
                    id: 2,
                    text: 'Готовый стейк положить на решетку и подставить тарелку, чтобы в нее стекал мясной сок.'
                },
                {
                    id: 3,
                    text: 'Из сковороды слить масло, но не выбрасывать прижарившиеся кусочки. Залить горячую сковороду оливковым маслом, бросить два раздавленных зубчика чеснока, иголки розмарина и цедру половины лимона.'
                },
                {
                    id: 4,
                    text: 'Дать маслу пять минут настояться в остывающей сковороде, выжать в него сок лимона, процедить через мелкое сито и смешать с соком, вытекшим из поджаренного мяса.'
                },
                {
                    id: 5,
                    text: 'Нарезать стейк тонкими ломтиками, полить частью соуса, посолить и поперчить. Сверху разложить смешанную с соусом рукколу, посыпать пармезаном.'
                }
            ]
        },
      13: {
            name: 'Сэндвич с яичницей, беконом и сыром',
            time: '5 минут',
            portion: '1 порция',
            image: '/static/images/recieps/rec13.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'БЕКОН',
                    value: '10 г'
                },
                {
                    index: 1,
                    text: 'БЕЛЫЙ ХЛЕБ',
                    value: '½ штуки'
                },
                {
                    index: 2,
                    text: 'СЫР ЭДАМ',
                    value: '20 г'
                },
                {
                    index: 3,
                    text: 'ПОМИДОРЫ',
                    value: '1 штука'
                },
                {
                    index: 4,
                    text: 'МАЙОНЕЗ',
                    value: '1 столовая ложка'
                },
                {
                    index: 5,
                    text: 'СЛИВОЧНОЕ МАСЛО',
                    value: '10 г'
                },
                {
                    index: 6,
                    text: 'ЯЙЦО КУРИНОЕ',
                    value: '1 штука'
                },
                {
                    index: 7,
                    text: 'ЛИСТЬЯ ЛАТУКА',
                    value: '3 штуки'
                },

            ],
            instruction: [
                {
                    id: 0,
                    text: 'Поджарить тонкие ломтики бекона до золотистой корочки.'
                },
                {
                    id: 1,
                    text: 'Подогреть хлеб и одну половину сэндвича намазать майонезом (можно приготовить самостоятельно), на вторую положить сыр, ломтики помидоров, бекон и латук.'
                },
                {
                    id: 2,
                    text: 'Тем временем на сливочном масле поджарить небольшую глазунью — такую, чтобы желток был полуготовым.'
                },
                {
                    id: 3,
                    text: 'Выложить глазунью на латук, закрыть другой половинкой сэндвича и подавать.'
                }
            ]
        },
      14: {
            name: 'Шаверма в пите',
            time: '1 ЧАС + 1 ЧАС',
            portion: '4 порции',
            image: '/static/images/recieps/rec14.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'ПИТА',
                    value: '4 штуки'
                },
                {
                    index: 1,
                    text: 'КУРИНОЕ ФИЛЕ',
                    value: '2 куска'
                },
                {
                    index: 2,
                    text: 'ПОМИДОРЫ',
                    value: '3 штуки'
                },
                {
                    index: 3,
                    text: 'ЗЕЛЕНЬ',
                    value: 'по вкусу'
                },
                {
                    index: 4,
                    text: 'ОГУРЦЫ',
                    value: '2 штуки'
                },
                {
                    index: 5,
                    text: 'МАЙОНЕЗ',
                    value: '6 столовых ложек'
                },
                {
                    index: 6,
                    text: 'СМЕТАНА',
                    value: '6 столовых ложек'
                },
                {
                    index: 7,
                    text: 'РЯЖЕНКА',
                    value: '6 столовых ложек'
                },
                {
                    index: 8,
                    text: 'ЧЕСНОК',
                    value: 'по вкусу'
                },
                {
                    index: 9,
                    text: 'КУРИНЫЙ БУЛЬОННЫЙ КУБИК',
                    value: '½ штуки'
                },
                {
                    index: 10,
                    text: 'КАРРИ',
                    value: 'по вкусу'
                },
                {
                    index: 11,
                    text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                    value: 'по вкусу'
                },

            ],
            instruction: [
                {
                    id: 0,
                    text: 'Смешать майонез, сметану и ряженку в соотношении 1:1:1. Выдавить через чеснокодавилку чеснок. Раскрошить бульонный кубик. Нарезать зелень. Все тщательно перемешать. Закрыть крышкой и убрать в холодильник минимум на час. Соус должен настояться, чем дольше стоит, тем вкуснее будет.'
                },
                {
                    id: 1,
                    text: 'Промыть, просушить. Нарезать на небольшое кусочки. Разогреть растительное масло, выложить курицу, посыпать карри. Обжаривать до румяной корочки. Перед сборкой покромсать, я для этого использую ножницы.'
                },
                {
                    id: 2,
                    text: 'Нарезать салат из помидоров и огурцов небольшими кубиками. (овощи можете добавлять какие душе угодно)'
                },
                {
                    id: 3,
                    text: 'Питу готовим перед подачей. Ее нужно раскрыть, чтобы получились конвертики, можно разрезать пополам, тогда получится много маленьких шаверм. Капнуть на сковороду капельку масла, разогреть. Обжарить питу буквально несколько секунд с обеих сторон.'
                },
                {
                    id: 4,
                    text: 'Далее собираем шаверму. Я все выкладываю слоями: соус, курица, соус, салат, соус, курица, соус, салат, соус. А можно все ингредиенты смешать.'
                }
            ]
        },
      15: {
            name: 'Ягненок на гриле с соусом персийяд',
            time: '40 МИНУТ + 1 ЧАС',
            portion: '2 ПОРЦИИ',
            image: '/static/images/recieps/rec15.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'ЧЕСНОК',
                    value: '1 головка'
                },
                {
                    index: 1,
                    text: 'ОЛИВКОВОЕ МАСЛО',
                    value: '240 мл'
                },
                {
                    index: 2,
                    text: 'КАРЕ ЯГНЕНКА',
                    value: '450 г'
                },
                {
                    index: 3,
                    text: 'СОЛЬ',
                    value: 'по вкусу'
                },
                {
                    index: 4,
                    text: 'ПОРТВЕЙН',
                    value: '100 мл'
                },
                {
                    index: 5,
                    text: 'ПЕТРУШКА',
                    value: '1 пучок'
                },
                {
                    index: 6,
                    text: 'СВЕЖИЙ РОЗМАРИН',
                    value: '2 стебля'
                },
                {
                    index: 7,
                    text: 'ЧЕСНОЧНОЕ МАСЛО',
                    value: '100 мл'
                },
                {
                    index: 8,
                    text: 'ХЕРЕСНЫЙ УКСУС',
                    value: '2 столовые ложки'
                },
                {
                    index: 9,
                    text: 'САХАР',
                    value: '100 г'
                },
                {
                    index: 10,
                    text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                    value: 'по вкусу'
                }

            ],
            instruction: [
                {
                    id: 0,
                    text: 'Чеснок разобрать на зубчики, три отложить, остальные залить в сотейнике 180 мл оливкового масла. На слабом огне томить час, не давая закипеть. За это время чеснок станет прозрачным и мягким. Остудить.'
                },
                {
                    id: 1,
                    text: 'Оставшееся оливковое масло и 30 мл портвейна смешать с тремя зубчиками чеснока, стеблями петрушки (листья оборвать и сохранить), веточкой розмарина и парой щепоток черного перца. Влить маринад в емкость для запекания и погрузить в него куски ягненка. Затянуть пленкой и убрать в холодильник на час.'
                },
                {
                    id: 2,
                    text: 'Для персийяда смешать томленый чеснок с чесночным маслом, уксусом, измельченными листьями петрушки и розмарина, посолить и поперчить. В сотейнике смешать сахар, оставшийся портвейн, щепотку соли и на среднем огне уварить на две трети.'
                },
                {
                    id: 3,
                    text: 'Разогреть гриль. Мясо выложить на решетку и поджарить до корочки с обеих сторон, переложить на тарелки и полить сиропом. Подавать с соусом персийяд.'
                }
            ]
        },


      16: {
            name: 'Цыпленок гриль с орегано',
            time: '2 ЧАСА + 1 СУТКи',
            portion: ' 8 ПОРЦИЙ',
            image: '/static/images/recieps/rec16.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'ЛИМОН',
                    value: '5 штук'
                },
                {
                    index: 1,
                    text: 'БЕЛОЕ СУХОЕ ВИНО',
                    value: '100 мл'
                },
                {
                    index: 2,
                    text: 'ОЛИВКОВОЕ МАСЛО EXTRA VIRGIN',
                    value: '120 мл'
                },
                {
                    index: 3,
                    text: 'СВЕЖИЕ ЛИСТЬЯ ОРЕГАНО',
                    value: '60 г'
                },
                {
                    index: 4,
                    text: 'ЛУК РЕПЧАТЫЙ',
                    value: '½ головки'
                },
                {
                    index: 5,
                    text: 'ЦЫПЛЕНОК',
                    value: '4 кг'
                },
                {
                    index: 6,
                    text: 'СОЛЬ',
                    value: 'по вкусу'
                },
                {
                    index: 7,
                    text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                    value: 'по вкусу'
                },
                {
                    index: 8,
                    text: 'ЛИСТЬЯ ТИМЬЯНА',
                    value: '20 г'
                },

            ],
            instruction: [
                {
                    id: 0,
                    text: '90 мл свежевыжатого лимонного сока, вино, 100 мл оливкового масла, орегано, тимьян, а также чайную ложку соли, пол чайной ложки черного перца и лук взбить в комбайне. Перелить в герметичную емкость и убрать в холодильник на ночь.'
                },
                {
                    id: 1,
                    text: 'У цыплят удалить шеи, грудинные кости и хребты (в 49-м номере «Афиши–Еда» можно найти мастер-класс, где на примере утки показана техника избавления птицы от костей). Поместить тушки в миску, посолить и поперчить, залить маринадом и поставить в холодильник на двенадцать часов.'
                },
                {
                    id: 2,
                    text: 'Разогреть гриль. Деревянными шампурами проткнуть тушки поперек в области грудок под крылышками и в области бедер так, чтобы обе голени оказались скреплены. Так цыплята прожарятся равномерно.'
                },
                {
                    id: 3,
                    text: 'Оставшиеся целые лимоны разрезать пополам, срезы смазать оливковым маслом и посыпать солью и перцем.'
                },
                {
                    id: 4,
                    text: 'Выложить цыплят на решетку кожей вниз и жарить под крышкой десять минут. Затем повернуть на 90 градусов по часовой стрелке, снова закрыть и жарить десять минут. Так же повернуть еще дважды, потом перевернуть кожей вверх и жарить двадцать минут, каждые пять минут поворачивая на 90 градусов. Переложить готовых цыплят на блюдо, а на гриль срезами вниз выложить лимоны на пятнадцать минут.'
                },
                {
                    id: 5,
                    text: 'Из цыплят вынуть шампуры, тушки разрезать на четыре части. Подавать с лимонными доль­ками.'
                }
            ]
        },
      17: {
            name: 'Шашлычки из курицы, креветок и овощей',
            time: '15 МИНУТ + 1 ЧАС',
            portion: '2 ПОРЦИИ',
            image: '/static/images/recieps/rec17.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'КУРИНОЕ ФИЛЕ',
                    value: '300 г'
                },
                {
                    index: 1,
                    text: 'КРЕВЕТКИ',
                    value: '300 г'
                },
                {
                    index: 2,
                    text: 'ГРИБЫ ШИИТАКЕ',
                    value: '150 г'
                },
                {
                    index: 3,
                    text: 'ПОМИДОРЫ ЧЕРРИ',
                    value: '150 г'
                },
                {
                    index: 4,
                    text: 'СОЕВЫЙ СОУС',
                    value: '40 мл'
                },
                {
                    index: 5,
                    text: 'СОЛЬ',
                    value: 'по вкусу'
                },
                {
                    index: 6,
                    text: 'СВЕЖИЙ ИМБИРЬ',
                    value: '20 г'
                }

            ],
            instruction: [
                {
                    id: 0,
                    text: 'Имбирь очистить и натереть на крупной терке. Курицу нарезать небольшими кусочками, креветки, если нужно, очистить от панциря и избавить от темной жилки-пищевода. Натереть курицу и креветки солью, перемешать с имбирем (все это надо делать в разной посуде) и оставить настояться в этом маринаде креветки и курицу — примерно на час.'
                },
                {
                    id: 1,
                    text: 'Подготовить посуду: лучше, чтобы это была сковорода гриль. Обычная тоже подойдет, но она должна быть такой, чтобы шпажки с мясом полностью в нее помещались.'
                },
                {
                    id: 2,
                    text: 'Замаринованное куриное мясо и креветки нанизать на бамбуковые шпажки, оставляя между кусочками небольшое расстояние. Для овощного шашлыка — по очереди черри и шиитаке.'
                },
                {
                    id: 3,
                    text: 'Сковороду хорошо разогреть и на сильном огне обжарить все шашлыки, периодически переворачивая, в конце каждый шашлычок сбрызнуть соевым соусом. Но важно не перестараться — все зависит от коли­чества соли, добавленной в маринад.'
                }
            ]
        },
      18: {
            name: 'Ягненок тандури',
            time: '1 ЧАС 10 МИНУТ + 8 ЧАСОВ',
            portion: '6 ПОРЦИЙ',
            image: '/static/images/recieps/rec18.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'РЕБРА ЯГНЕНКА',
                    value: '900 г'
                },
                {
                    index: 1,
                    text: 'КУМИН (ЗИРА)',
                    value: '1 столовая ложка'
                },
                {
                    index: 2,
                    text: 'ГАРАМ-МАСАЛА',
                    value: '1 столовая ложка'
                },
                {
                    index: 3,
                    text: 'ЧЕСНОК',
                    value: '8 зубчиков'
                },
                {
                    index: 4,
                    text: 'СВЕЖИЙ ИМБИРЬ',
                    value: '20 г'
                },
                {
                    index: 5,
                    text: 'СОЛОДОВЫЙ УКСУС',
                    value: '60 мл'
                },
                {
                    index: 6,
                    text: 'ГРЕЧЕСКИЙ ЙОГУРТ',
                    value: '125 мл'
                },
                {
                    index: 7,
                    text: 'КАЙЕНСКИЙ ПЕРЕЦ',
                    value: '3 чайные ложки'
                },
                {
                    index: 8,
                    text: 'КРАСНЫЙ ПИЩЕВОЙ КРАСИТЕЛЬ',
                    value: '1,5 чайные ложки'
                },
                {
                    index: 9,
                    text: 'МОЛОТЫЙ КАРДАМОН',
                    value: '2 чайные ложки'
                },
                {
                    index: 10,
                    text: 'МУСКАТНЫЙ ОРЕХ',
                    value: '1 чайная ложка'
                },
                {
                    index: 11,
                    text: 'ЛИМОН',
                    value: '1 штука'
                },
                {
                    index: 12,
                    text: 'СЛИВОЧНОЕ МАСЛО',
                    value: 'по вкусу'
                },
                {
                    index: 13,
                    text: 'СОЛЬ',
                    value: 'по вкусу'
                },
                {
                    index: 14,
                    text: 'СОЛЬ',
                    value: 'по вкусу'
                },

            ],
            instruction: [
                {
                    id: 0,
                    text: 'ложить ребра в глубокий противень. На сковороде обжарить кумин и гарам-масала в течение тридцати секунд, остудить. Растереть в порошок. Чеснок и имбирь взбить в блендере, добавить кумин и гарам-масала, йогурт, уксус, кайенский перец, кардамон, краситель, мускатный орех, соль, перец и сок лимона. Залить ребра и поставить в холодильник на ночь.'
                },
                {
                    id: 1,
                    text: 'Разогреть гриль. Обжаривать ребра с двух сторон двадцать минут. Слегка остудить и полить растопленным маслом.'
                }
            ]
        },
      19: {
            name: 'Говяжьи шашлычки',
            time: '20 МИНУТ + 4 ЧАСА',
            portion: '4 ПОРЦИИ',
            image: '/static/images/recieps/rec19.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'СОЕВЫЙ СОУС',
                    value: '80 мл'
                },
                {
                    index: 1,
                    text: 'ГОВЯЖЬЕ ФИЛЕ',
                    value: '800 г'
                },
                {
                    index: 2,
                    text: 'КИНЗА',
                    value: '50 г'
                },
                {
                    index: 3,
                    text: 'ЦЕДРА АПЕЛЬСИНА',
                    value: '2 столовые ложки'
                },
                {
                    index: 4,
                    text: 'РЫБНЫЙ СОУС',
                    value: '4 столовые ложки'
                },
                {
                    index: 5,
                    text: 'КОРИЧНЕВЫЙ САХАР',
                    value: '1,5 чайные ложки'
                },
                {
                    index: 6,
                    text: 'РАСТИТЕЛЬНОЕ МАСЛО',
                    value: '1 чайная ложка'
                },
                {
                    index: 7,
                    text: 'ЧЕСНОК',
                    value: '3 зубчика'
                }

            ],
            instruction: [
                {
                    id: 0,
                    text: 'Соевый соус, кинзу, цедру апельсина, рыбный соус, сахар, масло и чеснок взбить в блендере. Говядину нарезать на тонкие полоски толщиной в 5 мм и шириной в 2 см. Смешать в миске с маринадом. Оставить на четыре часа.'
                },
                {
                    id: 1,
                    text: 'Разогреть гриль. Нанизать мясо на деревянные шампуры и поджарить в течение пяти минут, один раз в процессе приготовления перевернув. Сразу подавать. Шампуры предварительно лучше вымочить в воде в течение получаса, чтобы они не сгорели на решетке. Или использовать стальные.'
                },
            ]
        },
      20: {
            name: 'Шашлык из страуса',
            time: '30 МИНУТ',
            portion: '4 ПОРЦИИ',
            image: '/static/images/recieps/rec20.jpg',
            ingredients: [
                {
                    index: 0,
                    text: 'ФИЛЕ СТРАУСА',
                    value: '1 кг'
                },
                {
                    index: 1,
                    text: 'ЛУК РЕПЧАТЫЙ',
                    value: '1 головка'
                },
                {
                    index: 2,
                    text: 'ОЛИВКОВОЕ МАСЛО',
                    value: '2 столовые ложки'
                },
                {
                    index: 3,
                    text: 'СОЛЬ',
                    value: '1 чайная ложка'
                },
                {
                    index: 4,
                    text: 'ПЕРЕЦ МОЛОТЫЙ ЧЕРНЫЙ',
                    value: 'по вкусу'
                },

            ],
            instruction: [
                {
                    id: 0,
                    text: 'Филе страуса нарезать на куски среднего размера.'
                },
                {
                    id: 1,
                    text: 'Лук нарезать полукольцами и перемешать его с мясом. Сбрызнуть шашлык оливковым маслом, посолить и поперчить. Оставить мариноваться на два часа. Два часа — это максимум, страусиное мясо быстро впитывает все необходимое.'
                },
                {
                    id: 2,
                    text: 'Выложить мясо на решетку над огнем и обжарить с двух сторон. Идеальная прожарка — средняя, то есть medium или medium rare.'
                }
            ]
        },
    }
}






// WEBPACK FOOTER //
// ./src/store/state.js